document.addEventListener('DOMContentLoaded', function() {
  // 1. We find each piece we need by name or ID or class.
  var storeHoursLocation = document.getElementById('store-hours-location');
  var sidebar            = document.getElementById('halo-store-hours-sidebar');
  var overlay            = document.getElementById('halo-store-hours-overlay');
  var closeButton        = document.getElementById('halo-store-hours-close');

  // NEW LINE: Instead of using <body>, we grab the element with class "body-content-wrapper"
  var bodyWrapper        = document.querySelector('.body-content-wrapper');

  // 2. Check if everything exists
  if (
    !storeHoursLocation ||
    !sidebar ||
    !overlay ||
    !closeButton ||
    !bodyWrapper
  ) {
    return;
  }

  // 3. This function opens the sidebar and the overlay
  function openStoreHours() {
    sidebar.classList.add('open');
    overlay.classList.add('open');

    // NEW LINE: Lock the background by adding a class to bodyWrapper
    bodyWrapper.classList.add('halo-body-no-scroll');
  }

  // 4. This function closes the sidebar and overlay
  function closeStoreHours() {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');

    // NEW LINE: Unlock the background by removing that class
    bodyWrapper.classList.remove('halo-body-no-scroll');
  }

  // 5. When you click the #store-hours-location DIV, open the sidebar
  storeHoursLocation.addEventListener('click', function(e) {
    e.preventDefault();
    openStoreHours();
  });

  // 6. When you click the Close button, close the sidebar
  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeStoreHours();
  });

  // 7. When you click the overlay background, also close
  overlay.addEventListener('click', closeStoreHours);
});
